import { dataLoaded, storeTTData, storeTTFile } from "@/redux/actions/trade-trust";
import api from '@/services/api/recordDetails.js';
import { getDataFromIndexedDB, isIndexedDBAvailable } from "@/utils/indexedDB";
import { immerable } from 'immer';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

class RecordDetail {

	[immerable] = true

	constructor(params) {
		this.isVerified = params.isVerified
		this.verificationFragments = params.verificationFragments
		this.networkLabel = params.networkLabel
		this.domainName = params.domainName
		this.nftRegistry = params.nftRegistry
		this.endorsementChain = params.endorsementChain
		this.owner = params.owner
		this.holder = params.holder
		this.docData = params.docData
		this.renderUrl = params.renderUrl
		this.tokenRegistryAddress = params.tokenRegistryAddress
		this.tokenId = params.tokenId
		this.canOpenAttachmentArray = params.canOpenAttachmentArray
		this.nominatedBeneficiary = params.nominatedBeneficiary
		this.ttStatus = params.ttStatus
		this.ttDocument = params.ttDocument
		this.timeFetch = new Date().getTime()
	}
}

let ttData = null;
let ttFile = null;

const useRecordDetail = () => {
	const [recordDetailData, setRecordDetailData] = useState([])
	const [recordDetailLoading, setRecordDetailLoading] = useState(false)
	const [recordDetailErrorMsg, setRecordDetailErrorMsg] = useState()

	const dispatch = useDispatch();

	const { hasLoadedData } = useSelector(state => state.tt);

	useEffect(() => {
		const fetchData = async () => {
			if (hasLoadedData) {
				return;
			}

			let data, file;

			if (isIndexedDBAvailable()) {
				data = await getDataFromIndexedDB("ttDataDB", "ttData");
				file = await getDataFromIndexedDB("ttFileDB", "ttFile");
			} else {
				data = ttData;
				file = ttFile;
			}

			if (data) dispatch(storeTTData(data));
			if (file) dispatch(storeTTFile(file));

			dispatch(dataLoaded());
		};

		fetchData().catch(error => {
			console.error('Failed to fetchData:', error);
		});
	}, [dispatch, hasLoadedData]);

	async function uploadRecordDetail(file) {
		if (!file) return;

		setRecordDetailLoading(true)

		const [error, response] = await api.upload(file)

		setRecordDetailLoading(false)

		if (error) {
			const message = 'Record Detail API has error';
			return setRecordDetailErrorMsg(message)
		}

		const serializedData = serialize(response)
		const newItems = new RecordDetail(serializedData)
		dispatch(storeTTData(newItems));
    	dispatch(storeTTFile(file));
		setRecordDetailData(newItems)
	}

	function serialize(entry) {
		return {
			isVerified: entry.isVerified,
			verificationFragments: entry.verificationFragments,
			networkLabel: entry.networkLabel,
			domainName: entry.domainName,
			nftRegistry: entry.nftRegistry,
			endorsementChain: entry.endorsementChain,
			owner: entry.owner,
			holder: entry.holder,
			docData: entry.docData,
			ttDocument: entry.ttDocument,
			renderUrl: entry.renderUrl,
			tokenRegistryAddress: entry.tokenRegistryAddress,
			tokenId: entry.tokenId,
			canOpenAttachmentArray: entry.canOpenAttachmentArray,
			nominatedBeneficiary: entry.nominatedBeneficiary,
			ttStatus: entry.ttStatus
		}
	}

	return {
		recordDetailErrorMsg,
		recordDetailData,
		recordDetailLoading,
		uploadRecordDetail,
		setRecordDetailLoading,
		RecordDetail,
		serialize
	}

}

export default useRecordDetail
